import { type AgentApprovalMode } from '@libraries/typescript/api_client';

export const AUTO_APPROVAL_RULES_LABEL = 'Always ask me before…';
export const AUTO_APPROVAL_RULES_PLACEHOLDER =
    'texting more than one caregiver';
export const AUTO_APPROVAL_RULES_MAX_LENGTH = 2_000;

export const AGENCY_SCOPE_LABEL = 'Approval mode for your agency';
export const AGENCY_SCOPE_HINT = 'Applies to your whole agency';
export const APPROVAL_MODE_READ_ONLY_HINT =
    'Only admins and schedulers can change this.';

/** One source of truth, so a mode is never named two ways. */
export const APPROVAL_MODE_OPTIONS: Readonly<
    Record<
        AgentApprovalMode,
        Readonly<{ readonly label: string; readonly description: string }>
    >
> = {
    review: {
        label: 'Ask first',
        description: 'Asks before texting, calling or changing settings',
    },
    auto: {
        label: 'Auto',
        description: 'Acts on its own, except where you say otherwise',
    },
    autopilot: {
        label: 'Autopilot',
        description: 'Acts on its own, always',
    },
};

export type ApprovalSettingsPatch = Readonly<{
    readonly agent_v3_approval_mode?: AgentApprovalMode;
    readonly agent_v3_approval_instructions?: string;
}>;

/**
 * The organization's approval mode and rules, shared by every chat.
 *
 * Data only. Writing them, and whether a write is in flight, belongs to
 * `useAgentApprovalSettings`, so a reader never carries a way to save.
 */
export type ApprovalSettings = Readonly<{
    readonly loaded: boolean;
    readonly mode: AgentApprovalMode;
    readonly rules: string | null;
    readonly autoAvailable: boolean;
    readonly canSave: boolean;
}>;

export const UNAVAILABLE_APPROVAL_SETTINGS: ApprovalSettings = {
    loaded: false,
    mode: 'review',
    rules: null,
    autoAvailable: false,
    canSave: false,
};

export function approvalModeChangedMessage(label: string): string {
    return `Now on ${label} for the whole agency.`;
}
